import React, { useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export const HorizontalScroll = ({ children, title, subtitle, className = '' }) => {
  const scrollRef = useRef(null);

  const scroll = (direction) => {
    if (!scrollRef.current) return;
    const amount = scrollRef.current.offsetWidth * 0.75;
    scrollRef.current.scrollBy({ left: direction === 'left' ? -amount : amount, behavior: 'smooth' });
  };

  return (
    <div className={className}>
      {(title || subtitle) && (
        <div className="flex items-end justify-between mb-5 px-1">
          <div>
            {title && <h2 className="text-2xl md:text-3xl font-bold text-gray-900">{title}</h2>}
            {subtitle && <p className="text-sm text-gray-500 mt-1">{subtitle}</p>}
          </div>
          <div className="hidden sm:flex items-center gap-2">
            <button
              onClick={() => scroll('left')}
              className="w-9 h-9 rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-100 transition-colors"
              aria-label="Scroll left"
              data-testid="scroll-left-btn"
            >
              <ChevronLeft size={18} className="text-gray-600" />
            </button>
            <button
              onClick={() => scroll('right')}
              className="w-9 h-9 rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-100 transition-colors"
              aria-label="Scroll right"
              data-testid="scroll-right-btn"
            >
              <ChevronRight size={18} className="text-gray-600" />
            </button>
          </div>
        </div>
      )}
      <div
        ref={scrollRef}
        className="flex gap-4 overflow-x-auto scroll-smooth snap-x snap-mandatory pb-4 -mx-1 px-1"
        style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          WebkitOverflowScrolling: 'touch',
        }}
        data-testid="horizontal-scroll-container"
      >
        <style>{`
          [data-testid="horizontal-scroll-container"]::-webkit-scrollbar { display: none; }
        `}</style>
        {children}
      </div>
    </div>
  );
};

export const ScrollCard = ({ children, className = '', width = 'w-56 sm:w-64' }) => (
  <div className={`${width} shrink-0 snap-start ${className}`}>
    {children}
  </div>
);
